import Vue from 'vue'

/*
* AG Grid Methods here
*/
export default Vue.extend({
  methods: {
    intlNumberFormatter (number, locale, options) {
      if (typeof number === 'string') number = parseFloat(number)
      if (typeof number !== 'number' && !isNaN(Number(number))) return null
      const hideDecimals = (this.displayOptions || {}).hideDecimals || false
      const useParentheses = (this.displayOptions || {}).showNegativesInParenthesesInWorkSheet || false

      if (!locale) locale = 'en-us'

      if (!options) {
        options = {
          style: 'decimal',
          useGrouping: true,
          minimumFractionDigits: hideDecimals ? 0 : 2,
          maximumFractionDigits: hideDecimals ? 0 : 2
        }
      }

      let result = new Intl.NumberFormat(locale, options).format(number)

      // -0 should be just 0
      if (result === '-0' || result === '-0.00') {
        result = new Intl.NumberFormat(locale, options).format(0)
      }

      // currencySign option is not working on many browsers so manually handle
      if (useParentheses && result.slice(0, 1) === '-') {
        result = '(' + result.slice(1) + ')'
      }

      return result
    },

    /*
    * Check lines are editable or not
    */
    isEditable (params) {
      // Payment transactions
      if (['WIRE', 'EFT', 'MC', 'CK'].includes(params.data.trans_type)) {
        return false
      }
      // offset line
      const lineSet = params.data.set ? params.data.set : ''
      const lineSer = params.data.series ? params.data.series : ''
      const lineLoc = params.data.location ? params.data.location : ''
      let checkText = 'SLS: #' + lineSer + '-' + lineLoc + '-' + lineSet
      const matches = ['AR Offset', 'Receipt Offset', 'PETTY CASH OFFSET', 'PCARD OFFSET', 'Credit Card Offset', 'Payroll Offset', 'Payroll Clearing', 'Fringe Clearing', 'Payroll Clearing Offset', '# PAYROLL OFFSET', '# FRINGE PAYROLL OFFSET', 'PAYROLL OFFSET', 'FRINGE PAYROLL OFFSET']
      if ((matches.includes(params.data.line_desc) && params.data.trans_type !== 'AP') || params.data.line_desc.match('PETTY CASH ADVANCE') || params.data.line_desc.match(checkText) || params.data.line_desc.match('A/P Offset') || params.data.line_desc.match('relieved')) {
        return false
      }

      if (params.data.trans_type === 'PO') {
        if (params.data.transaction_status === 'POSTED') {
          if (params.data.line_type !== 'OPEN') {
            return false
          }
        } else {
          // Allow edits for set, location and series columns for CLOSED POs
          if (params.data.transaction_status === 'CLOSED') {
            if (!['set', 'location', 'series'].includes(params.colDef.colId)) {
              return false
            }
          }
        }
      }
      return true
    },

    customSum (params) {
      let sum = 0
      params.values.forEach((value) => {
        let number = parseFloat(String(value || 0).replace(/,/g, ''))
        if (number && !isNaN(number)) sum += number
      })
      if (isNaN(sum) || sum === 0) {
        return ''
      } else {
        return sum.toFixed(2)
      }
    },

    customList (values) {
      let list = []
      values.forEach((value) => {
        if (value && list.indexOf(value) === -1) list.push(value)
      })
      if (list.length > 0) {
        return list.join(',')
      } else {
        return ''
      }
    },

    customSumSelected (params) {
      let sum = 0
      if (params.values && params.rowNode.allChildrenCount) {
        params.rowNode.allLeafChildren.filter((node) => {
          if (node.selected && node.data.attributes) {
            let number = parseFloat(String(node.data.attributes.amount_decimal || 0).replace(/,/g, ''))
            if (number && !isNaN(number)) sum += number
          }
        })
      }
      return sum.toFixed(2)
    },

    /*
     * Need this to make sure we get a valid link
    */
    buildTransLink (data) {
      let type
      switch (data.src) {
        case 'AP':
          type = 'aps'
          break

        case 'PC':
          type = 'pettycash'
          break

        case 'PO':
          type = 'pos'
          break

        case 'RT':
          type = 'rts'
          break

        case 'creditcard':
        case 'CC':
          type = 'ccs'
          break

        case 'PR':
        case 'clientpayroll':
          type = 'prs'
          break

        default:
          type = 'jes'
      }
      return '<a style="color:#007bff" target="_blank" href="/' + type + '/' + data.transaction_id + '">View</a>'
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/GeneralLedgerWorksheet/ColumnMethods.js